import { render, staticRenderFns } from "./AdminLoginController.vue?vue&type=template&id=64d19daf&"
import script from "./AdminLoginController.vue?vue&type=script&lang=js&"
export * from "./AdminLoginController.vue?vue&type=script&lang=js&"
import style0 from "./AdminLoginController.vue?vue&type=style&index=0&id=64d19daf&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports